// extracted by mini-css-extract-plugin
module.exports = {"sideNav":"SideNav--sideNav--1v2UY","isOpen":"SideNav--isOpen--WSyBo"};